import { Sparkles, Home, Leaf, Waves, TreePine, Building2, Palmtree } from "lucide-react";

// Category chips for the discovery header. The upstream API has no category
// tags yet, so we best-effort match against the property name/type/address.
export const CATEGORIES = [
  { id: "all", label: "All stays", icon: Sparkles },
  { id: "homestay", label: "Homestays", icon: Home, keywords: ["homestay", "home", "house", "haven", "villa", "nivas", "niwas"] },
  { id: "tea", label: "Tea Estates", icon: Leaf, keywords: ["tea", "estate", "bungalow", "plantation", "garden"] },
  { id: "river", label: "River View", icon: Waves, keywords: ["river", "riverfront", "lake", "waterfront", "brahmaputra", "beach"] },
  { id: "eco", label: "Eco Cottages", icon: TreePine, keywords: ["eco", "cottage", "cabin", "nature", "forest", "bamboo", "wood"] },
  { id: "hotel", label: "Hotels", icon: Building2, keywords: ["hotel", "inn", "suites", "residency", "grand"] },
  { id: "resort", label: "Resorts", icon: Palmtree, keywords: ["resort", "spa", "retreat", "beach"] },
];

export const matchesCategory = (hay, catId) => {
  if (!catId || catId === "all") return true;
  const cat = CATEGORIES.find((c) => c.id === catId);
  if (!cat?.keywords) return true;
  const h = (hay || "").toLowerCase();
  return cat.keywords.some((k) => h.includes(k));
};
